import {createContext, useContext} from 'react';

/**
 * Signals that a navigation transition is in progress.
 *
 * `StrictLocaleLoaderRouter` provides `isPending`: the router transition (`TransitionalRouter`,
 * webpack brands), the page-swap transition (`useTransition`, the one suspending on the new page
 * chunk and data) or a deferred location not yet applied. `useRoute` reads it to freeze the
 * current route while the previous page is still on screen.
 */
export const NavigationContext = createContext(false);

export const useIsNavigatingAway = (): boolean => useContext(NavigationContext);
